import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { handleErrorNotification } from 'Common/utils';
import { useDownloadSingleReceipt, useReceipts } from 'RKSV/hooks/logs';
import LogTable from './views/LogTable';

const LogsContainer = () => {
  const intl = useIntl();
  const { isLoading, data, error } = useReceipts();
  const downloadSingleReceiptMutation = useDownloadSingleReceipt();
  useEffect(() => {
    if (error) {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    }
  }, [error]);
  return (
    <LogTable
      loading={isLoading}
      receipts={data !== undefined ? data : []}
      download={downloadSingleReceiptMutation.mutate}
    />
  );
};

export default LogsContainer;
